export default class RouteNames {
  static readonly EDIT_VIEW_ROUTE: string = `EditView`;
  static readonly LIST_VIEW_ROUTE: string = `ListView`;
  static readonly REPORT_LIST_ROUTE: string = `rptlst`;
  static readonly LAUNCH_REPORT_ROUTE: string = `rpt`;
  static readonly REPORT_RESULT_ROUTE: string = `rptres`;
  static readonly UTILS_ROUTE:string = `utils`;
  static readonly VIEW_USERS_ROUTE:string = `viewusers`;
  static readonly MONITOR_TASKS_ROUTE:string = `monitortasks`;
  static readonly SQL_RUNNER_ROUTE:string = `sqlrunner`;
  static readonly WEBSOCKET_SESSIONS:string = `websocketsessions`;
  static readonly WELCOME_ROUTE:string = `welcome`;
  static readonly IMPL_WIZARD: string = `ImplWizard`;
  static readonly WIZARD_ROUTE: string = `WizardView`;
  static readonly SETTINGS_ROUTE: string = `SettingsView`;
  static readonly IMPL_BACKUP_BROWSER: string = `ImplBackupBrowser`;
  static readonly LAYOUT_EDITOR_ROUTE: string = `LayoutEditorView`;
  static readonly REPORT_WIZARD_EDITOR_ROUTE: string = `ReportWizardEditorView`;
  static readonly FILE_EDITOR_ROUTE: string = `FileEditorView`;
  static readonly TECHNICIAN_CALENDAR_ROUTE: string = `technicianAppointmentCreator`;
  static readonly MY_APPOINTMENTS_ROUTE: string = `myAppointments`;
}

export class CustomPlaceTokens {
  static readonly FORCE_REFRESH_KEY: string = `key`;
}
